import React, { useState } from 'react';
import { CardBody, Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import CreditPolicyFormAccordionSection from './CreditPolicyFormAccordionSection';

const CreditPolicyFormAccordion = ({sections}) => {
  const initialAccordion = Array(sections.length).fill(false);
  initialAccordion[0] = true;
  const [ accordion, setAccordion ] = useState(initialAccordion);

  const handleToggleAccordion = index => () => {
    setAccordion(accordion.map((bool, idx) => idx === index ? !bool : false));
  };

  return (
    <>
      {sections.map( (section, idx) => (
        <CreditPolicyFormAccordionSection
          key={section.name}
          title={section.name}
          toggle={handleToggleAccordion(idx)}
          collapsed={!accordion[idx]}
          isValid={section.isValid}
          expansible={section.expansible}
        >
          <Collapse isOpen={accordion[idx]}>
            <CardBody>
              {section.component}
            </CardBody>
          </Collapse>
        </CreditPolicyFormAccordionSection>
      ))}
    </>
  );
};

CreditPolicyFormAccordion.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CreditPolicyFormAccordion;
